// Global "credits empty" listener. Mount once near the app root.
//
// How it works
// ============
// `api.js` axios interceptor catches every 402 response from the backend
// and emits a `window` event `wyngx:credits-empty` with the action context
// (what the user tried to do, how many credits it would cost). This
// component listens for it and opens the existing TopUpModal so a single
// pop-up handles every credits-blocked action in the app — chat, AI
// coach, weekly report follow-up, anything else that uses
// consume_credits() server-side.
import { useEffect, useState } from "react";
import TopUpModal from "@/components/TopUpModal";

export default function CreditsGate() {
    const [ctx, setCtx] = useState(null);

    useEffect(() => {
        const handler = (e) => {
            // Coalesce rapid double-fires (e.g. retry handlers).
            setCtx((prev) => prev || (e.detail || {}));
        };
        window.addEventListener("wyngx:credits-empty", handler);
        return () => window.removeEventListener("wyngx:credits-empty", handler);
    }, []);

    return (
        <TopUpModal
            open={!!ctx}
            onClose={() => setCtx(null)}
            onPaid={() => setCtx(null)}
            requiredCredits={ctx?.required || 0}
        />
    );
}
